import { GeneralDashboardController } from '../../generalDashboard/GeneralDashboardController';
import template from '../../generalDashboard/GeneralDashboardView.html';
const GeneralDashboard = {
    template,
    controller: GeneralDashboardController,
    controllerAs: '$ctrl',
    bindings: {},
};
export default GeneralDashboard;
